import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { ValueProposition } from './components/ValueProposition';
import { Products } from './components/Products';
import { TripleExtract } from './components/TripleExtract';
import { HowItWorks } from './components/HowItWorks';
import { Subscription } from './components/Subscription';
import { Gallery } from './components/Gallery';
import { FAQ } from './components/FAQ';
import { Trust } from './components/Trust';
import { Contact } from './components/Contact';
import { FinalCTA } from './components/FinalCTA';
import { StickyWhatsApp } from './components/StickyWhatsApp';
export function App() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-green/20 selection:text-brand-green" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <ValueProposition data-id="element-5" />
        <Products data-id="element-6" />
        <TripleExtract data-id="element-7" />
        <HowItWorks data-id="element-8" />
        <Subscription data-id="element-9" />
        <Gallery data-id="element-10" />
        <FAQ data-id="element-11" />
        <Trust data-id="element-12" />
        <Contact data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      {/* Footer simple */}
      <footer className="bg-brand-brown text-brand-beige/60 py-8 text-center text-sm" data-id="element-15">
        <div className="max-w-7xl mx-auto px-4" data-id="element-16">
          <p data-id="element-17">
            © {new Date().getFullYear()} Oser Pro Labs. Todos los derechos
            reservados.
          </p>
        </div>
      </footer>

      <StickyWhatsApp data-id="element-18" />
    </div>;
}